// extracted by mini-css-extract-plugin
export default {"str":"nutrition_str__1KLak","border":"nutrition_border__L7bFM","Heading":"nutrition_Heading__kNmK8","values":"nutrition_values__nVDBg"};